import styled from 'styled-components'

const StyledIngredientExplanationContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`

export default StyledIngredientExplanationContainer
